/**
 * MIME Types cho các loại file download
 */
export enum MimeType {
  // Microsoft Office Documents
  WORD_DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  EXCEL_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  POWERPOINT_PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  
  // Legacy Microsoft Office
  WORD_DOC = 'application/msword',
  EXCEL_XLS = 'application/vnd.ms-excel',
  POWERPOINT_PPT = 'application/vnd.ms-powerpoint',
  
  // PDF
  PDF = 'application/pdf',
  
  // Archives
  ZIP = 'application/zip',
  RAR = 'application/vnd.rar',
  
  // Images
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  GIF = 'image/gif',
  
  // Text
  TEXT = 'text/plain',
  CSV = 'text/csv',
  
  // Generic
  OCTET_STREAM = 'application/octet-stream',
  JSON = 'application/json',
  XML = 'application/xml'
}

/**
 * Shortcuts cho các MIME types thường dùng
 */
export const CommonMimeTypes = {
  Word: MimeType.WORD_DOCX,
  Excel: MimeType.EXCEL_XLSX,
  PDF: MimeType.PDF,
  ZIP: MimeType.ZIP,
  CSV: MimeType.CSV,
  Default: MimeType.OCTET_STREAM
} as const;
